package learning.components


import antd.alert.alert
import antd.avatar.avatar
import antd.button.button
import antd.comment.comment
import antd.divider.divider
import antd.form.form
import antd.form.formItem
import antd.icon.likeOutlined
import antd.icon.messageOutlined
import antd.icon.questionOutlined
import antd.icon.starOutlined
import antd.input.input
import antd.input.textArea
import antd.layout.space
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.pagination.PaginationConfig
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.Content
import com.jingfangpai.common.orm.mapping.UserPermission
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.common.orm.mapping.enums.UserPermissionCommunity
import com.jingfangpai.common.orm.mapping.enums.UserPermissionContent
import com.jingfangpai.content.model.ContentQuery
import com.jingfangpai.content.model.ContentVo
import react.*
import community.containers.TopicsPageContext
import kotlinext.js.Object
import kotlinext.js.js
import kotlinext.js.jsObject
import kotlinx.html.js.onClickFunction
import kotlinx.html.unsafe
import learning.containers.TcmFaqsPageContext
import react.dom.*
import react.router.dom.useHistory
import user.service.CurrentUserPermission

external interface TcmFaqsProps : RProps {

}

val TcmFaqs = functionalComponent<TcmFaqsProps> { props ->

    val ctx = useContext(TcmFaqsPageContext)
    val history = useHistory()
    val (query,setQuery) = useState(ContentQuery().apply {
        type = ContentType.TcmFaq
        includeComments = true
    })
    val (topics,setTopics) = useState(arrayOf<ContentVo>())

    useEffectOnce {
        ctx.query(query,{ resp ->
            if(resp.ok()){
                setTopics(resp.data?:arrayOf())
            }else{
                message.error("获取问题题出错：${resp.message}")
            }
        },{
            message.error("获取问题出错：${it.message}")
        })
    }

    div("tcmFaqs") {
        list<ContentVo, ListComponent<ContentVo>> {
            attrs {
                itemLayout = "vertical"
                size = "large"
                pagination = jsObject<PaginationConfig> {
                    onChange = { page: Number, pageSize: Number? -> }
                    pageSize = 30
                }
                dataSource = topics
                renderItem = { item: ContentVo, index: Number ->
                    listItem {
                        attrs {
                            key = "${item.id}"
                            actions = arrayOf(
                                /*buildElement {
                                    space {
                                        starOutlined {}
                                        +"156"
                                    }
                                },
                                buildElement {
                                    space {
                                        likeOutlined {}
                                        +"156"
                                    }
                                },*/
                                /*buildElement {
                                    space {
                                        messageOutlined {}
                                        +"${item.comments.size}"
                                    }
                                },*/
                                if(item.comments.isEmpty() && CurrentUserPermission.hasPerm(UserPermissionContent.发布中医常见问题)) {
                                    buildElement {
                                        space {
                                            button {
                                                attrs {
                                                    onClick = {
                                                            history.push(
                                                                LearningRoute.TcmFaqAnswerEdit.link.url.replace(
                                                                    ":topicId",
                                                                    item.id ?: ""
                                                                ).replace(":commentId", "new")
                                                            )
                                                    }
                                                }
                                                +"回答问题"
                                            }
                                        }
                                    }
                                }else{
                                    buildElement {
                                        span{}
                                    }
                                }
                            )
                            /*extra = buildElement {
                                img {
                                    this.attrs {
                                        width = "272"
                                        alt = "logo"
                                        src = "https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
                                    }
                                }
                            }*/
                        }
                        listItemMeta {
                            attrs {
                                avatar = buildElement {
                                    questionOutlined {  }
                                }
                                title = buildElement {
                                    div {
                                        if(CurrentUserPermission.hasPerm(UserPermissionContent.发布中医常见问题)){
                                            a {
                                                attrs{
                                                    jsStyle = js{
                                                        float = "right"
                                                    }
                                                    onClickFunction = {
                                                        history.push(LearningRoute.TcmFaqEdit.link.url.replace(":id",item.id!!))
                                                    }
                                                }
                                                +"编辑"
                                            }
                                        }
                                        +"问题${index.toInt()+1}：${item.title ?: ""}"
                                    }
                                }
                                //description = "${item.description}"
                            }
                        }
                        alert {
                            attrs{
                                style = js{
                                    margin = "16px 0"
                                }
                                message = buildElement {
                                    div{
                                        attrs.unsafe {
                                            +"${item.content?:""}"
                                        }
                                    }
                                }
                            }
                        }
                        list<Comment,ListComponent<Comment>> {
                            attrs{
                                className = "comment-list"
                                header = /*if(item.comments.size>0) "${item.comments.size}条讨论" else "暂无讨论"*/"回答："
                                itemLayout = "horizontal"
                                dataSource = item.comments.toTypedArray()
                                renderItem = {commentItem,index ->
                                    buildElement {
                                        li {
                                            comment {
                                                attrs{
                                                    actions = arrayOf()
                                                    author = commentItem.createdBy
                                                    avatar = "https://joeschmoe.io/api/v1/random"
                                                    content = buildElement {
                                                        div{
                                                            div{
                                                                attrs.unsafe {
                                                                    +(commentItem.comment?:"")
                                                                }
                                                            }
                                                            if(CurrentUserPermission.hasPerm(UserPermissionContent.发布中医常见问题)) {

                                                                div {
                                                                    button {
                                                                        attrs {
                                                                            type = "link"
                                                                            onClick = {
                                                                                history.push(
                                                                                    LearningRoute.TcmFaqAnswerEdit.link.url.replace(
                                                                                        ":topicId",
                                                                                        item.id ?: ""
                                                                                    ).replace(
                                                                                        ":commentId",
                                                                                        commentItem.id ?: ""
                                                                                    )
                                                                                )
                                                                            }
                                                                        }
                                                                        +"修改回答"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    datetime = commentItem.timestamp
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                header = buildElement {
                    div {
                        span{
                            attrs {
                                jsStyle = js {
                                    float = "right"
                                }
                            }
                            if(CurrentUserPermission.hasPerm(UserPermissionContent.发布中医常见问题)) {
                                button {
                                    attrs {
                                        type = "primary"
                                        onClick = {
                                            history.push(LearningRoute.TcmFaqEdit.link.url.replace(":id", "new"))
                                        }
                                    }
                                    +"添加问题"
                                }
                            }
                        }
                        h2("title") {
                            +"常见问题"
                        }
                    }
                }
                footer = buildElement {
                    div{}
                }
            }
        }
    }
}
